<form [formGroup]="formGroup" *ngIf="data$ | async as data">
  <div class="flex" [ngClass]="displayAsRow ? 'row-display' : 'col-display'">
    <div class="text-sm flex items-center justify-between">
      {{ (data.isRequired ? '* ' : '') + label }}
      <span class="tooltip" [attr.data-tip]="tooltip">
        <fa-icon
          *ngIf="showExclamation"
          [icon]="faCircleInfo"
          class="text-2xl text-dark-40 ml-4"
        ></fa-icon>
      </span>
    </div>
    <div class="flex">
      <div class="flex m-3" *ngFor="let option of data.options">
        <input
          [id]="option.id"
          type="radio"
          formControlName="radio"
          [value]="option.value"
          class="cursor-pointer radio"
          [ngClass]="
            data.isTouched && data.errors && data.errors['required']
              ? 'radio-error-state'
              : 'radio-primary'
          "
        />
        <label
          [for]="option.id"
          class="pl-2 pt-[1px] cursor-pointer select-none"
          >{{ option.label }}</label
        >
      </div>
      <div
        class="flex m-3"
        *ngIf="data.isTouched && data.errors && data.errors['required']"
      >
        <div class="validation-error pt-[1px]">Please choose an option</div>
      </div>
    </div>
  </div>
</form>
